import React from 'react';
import { useWindowSize } from '@magento/peregrine/lib/hooks/useWindowSize';
import { useStyle } from '@magento/venia-ui/lib/classify';
import defaultClasses from './onlineDealers.module.css';
import OnlineDealerImage from '../../assets/online-dealer.jpg';
import globe from '../../assets/globe.png';

var OnlineDealerItem = function OnlineDealerItem(_ref) {
  var _item$url, _item$url2;

  var item = _ref.item,
      _ref$isPdpPage = _ref.isPdpPage,
      isPdpPage = _ref$isPdpPage === void 0 ? false : _ref$isPdpPage,
      propsClasses = _ref.classes,
      sanitizeUrlName = _ref.sanitizeUrlName;
  var classes = useStyle(defaultClasses, propsClasses);

  var _useWindowSize = useWindowSize(),
      innerWidth = _useWindowSize.innerWidth;

  var isSmallDevice = innerWidth < 768;
  return React.createElement("div", {
    className: classes.item
  }, (item === null || item === void 0 ? void 0 : item.image) !== 'https://hubbardtonforgem2.joladev.com/media/onlinedealers/' && React.createElement("div", {
    className: classes.onlineDealerImage
  }, React.createElement("a", {
    href: item !== null && item !== void 0 && (_item$url = item.url) !== null && _item$url !== void 0 && _item$url.includes('http') ? item === null || item === void 0 ? void 0 : item.url : 'https://' + (item === null || item === void 0 ? void 0 : item.url),
    target: "_blank",
    rel: "noopener"
  }, item !== null && item !== void 0 && item.image ? React.createElement("img", {
    src: item === null || item === void 0 ? void 0 : item.image,
    className: "w-full",
    alt: "online dealer"
  }) : React.createElement("img", {
    src: OnlineDealerImage,
    className: "w-full",
    alt: "online dealer"
  }))), React.createElement("div", {
    className: classes.details
  }, React.createElement("p", {
    className: "leading-171 text-bronze mt-0 md_mt-1.5"
  }, item === null || item === void 0 ? void 0 : item.name), isPdpPage && !isSmallDevice ? React.createElement("a", {
    href: item === null || item === void 0 ? void 0 : item.url,
    className: "underline font-bold leading-2",
    target: "_blank",
    rel: "noopener"
  }, "WEBSITE") : React.createElement("a", {
    href: item !== null && item !== void 0 && (_item$url2 = item.url) !== null && _item$url2 !== void 0 && _item$url2.includes('http') ? item === null || item === void 0 ? void 0 : item.url : 'https://' + (item === null || item === void 0 ? void 0 : item.url),
    target: "_blank",
    rel: "noopener"
  }, isSmallDevice ? React.createElement(React.Fragment, null, React.createElement("img", {
    src: globe,
    alt: "Website",
    className: "w-4 h-4"
  })) : React.createElement(React.Fragment, null, sanitizeUrlName(item === null || item === void 0 ? void 0 : item.url)))));
};

export default OnlineDealerItem;